define("shared/components/shared/ui/block", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes class={{this.primaryClass}}>
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@body}}
    {{/if}}
  </div>
  */
  {
    "id": "e+H+6kwp",
    "block": "[[[11,0],[17,1],[16,0,[30,0,[\"primaryClass\"]]],[12],[1,\"\\n\"],[41,[48,[30,3]],[[[1,\"    \"],[18,3,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[30,2]],[1,\"\\n\"]],[]]],[13]],[\"&attrs\",\"@body\",\"&default\"],false,[\"if\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/block.hbs",
    "isStrictMode": false
  });
  class BlockComponent extends _component2.default {
    get primaryClass() {
      return this.args?.primaryClass;
    }
  }
  _exports.default = BlockComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BlockComponent);
});